<template>

    <v-section>
        <h3>Our customers love us!</h3>
        <div class="testimonials">
            <div v-for="testimonial in testimonials" :key="testimonial.name" class="testimonial">
                <img class="photo mb-15" :src="testimonial.photo" />
                <div class="mb-10">
                    <div class="stars">
                        <i class="fas fa-star"></i>
                        <i class="fas fa-star"></i>
                        <i class="fas fa-star"></i>
                        <i class="fas fa-star"></i>
                        <i class="fas fa-star"></i>
                    </div>
                </div>
                <div class="quote mb-10" v-html="'&ldquo;' + testimonial.quote + '&rdquo;'" />
                <div class="name mb-5">{{ testimonial.name }}</div>
                <div class="title">{{ testimonial.title }} at <a :href="testimonial.link" target="_blank">{{ testimonial.company }}</a></div>
            </div>
        </div>
    </v-section>

</template>

<style scoped lang="scss">

    $gold: #a17f1a;

    .testimonials {
        display: grid;
        gap: 30px;
        grid-auto-flow: row;
        grid-template-columns: repeat(3, 1fr);
        @media (max-width: map-get($grid-breakpoints, 'lg')) {
            grid-template-columns: repeat(1, 1fr);
        }
    }

    .testimonial {
        width: 100%;
        .photo {
            background: $color-bg;
            border-radius: 50%;
            height: 120px;
            width: 120px;
        }
        .stars {
            @include font-medium(11px);
            background: rgba($gold, 0.2);
            border-radius: 16px;
            color: $gold;
            display: inline-block;
            letter-spacing: 2px;
            line-height: 30px;
            padding: 0 15px;
        }
        .quote {
            @include font-medium(15px);
            line-height: 1.6em;
        }
        .name {
            @include font-semibold(15px);
            line-height: 1.6em;
        }
        .title {
            @include font-medium(14px);
            line-height: 1.6em;
        }
        @media (max-width: map-get($grid-breakpoints, 'md')) {
            .quote, .name {
                font-size: 14px;
            }
        }
    }

</style>

<script>

export default {

    data() {
        return {
            testimonials: [
                this.$t('testimonial.pr24'),
                this.$t('testimonial.partnered'),
                this.$t('testimonial.peterteszary'),
            ],
        }
    },

}

</script>